export default __webpack_public_path__ + "static/media/react.acecaab0.svg";